/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ItauAtualizacaoCobrancaRecorrente {
  data?: string;
  status?: ItauAtualizacaoCobrancaRecorrente.StatusEnum;
}
export namespace ItauAtualizacaoCobrancaRecorrente {
  export type StatusEnum =
    | 'CRIADA'
    | 'ATIVA'
    | 'CONCLUIDA'
    | 'EXPIRADA'
    | 'REJEITADA'
    | 'CANCELADA';
  export const StatusEnum = {
    CRIADA: 'CRIADA' as StatusEnum,
    ATIVA: 'ATIVA' as StatusEnum,
    CONCLUIDA: 'CONCLUIDA' as StatusEnum,
    EXPIRADA: 'EXPIRADA' as StatusEnum,
    REJEITADA: 'REJEITADA' as StatusEnum,
    CANCELADA: 'CANCELADA' as StatusEnum
  };
}
